export const visit = (vm, at) => {
at({ "es-mx": { "conversationsVisitorUIAvailability": { "sameDay": "Volveremos hoy a las {{time}}", "nextDay": "Volveremos ma\xF1ana a las {{time}}.", "nextWeek": "Volveremos  el {{dayOfWeek}} a las {{time}}" } } });
};